import React from "react";
import { Box } from "@mui/material";
import {imgChampionQuiz} from "../../assets/images/champion_quiz";
import {imgMastarQuiz} from "../../assets/images/mastar_quiz";
import {imgVinnarQuiz} from "../../assets/images/vinnar_quiz";

const SelectQuiz = (props) => {
  const prepareQuiz = (mode) => {
    if (props.prepareQuiz) props.prepareQuiz(mode);
  };

  return (
    <Box sx={{
      marginTop: { xs: 10, md: 20 },
    }}>
      <Box
        component="img"
        sx={{
          height: { xs: 100, md: 150 },
          width: { xs: 240, md: 360 },
        }}
        alt="champion quiz"
        src={imgChampionQuiz}
        onClick={() => prepareQuiz(0)}
      />

      <Box
        component="img"
        sx={{
          height: { xs: 100, md: 150 },
          width: { xs: 240, md: 360 },
          marginLeft: {
            xs: 3,
            md: 6,
          },
        }}
        alt="master quiz"
        src={imgMastarQuiz}
        onClick={() => prepareQuiz(1)}
      />

      <Box
        component="img"
        sx={{
          height: { xs: 100, md: 150 },
          width: { xs: 240, md: 360 },
        }}
        alt="winner quiz"
        src={imgVinnarQuiz}
        onClick={() => prepareQuiz(2)}
      />
    </Box>
  );
};

export default SelectQuiz;
